import * as React from 'react';
export const bcSvg = React.forwardRef(function bcSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#E83E45',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M28 16.001C28 22.625 22.624 28 16 28S4 22.627 4 16.001 9.372 4 16 4s12 5.373 12 12.001ZM9.818 13.159a1.853 1.853 0 0 0-1.235-.228c.785-.838 1.213-1.75 1.213-2.669a2.18 2.18 0 0 0-.012-.254c-.04-.571-.304-1-.713-1.145-.408-.154-1.16-.076-2.35 1.142l-.716.801c-.198.242-.95 1.38-1.09 2.565-.233 2.014-.084 4.025.43 5.806.06.208.252.712.714.898.486.198.948-.039 1.36-.25l.009-.004.11-.054.425-.19.412-.182.502-.22.022-.009c.353-.144.686-.28 1.01-.553.439-.375.76-.865.926-1.423.086-.288.146-.603.176-.96.026-.277.056-.817-.05-1.29-.226-1.044-.745-1.543-1.145-1.78l.002-.001Zm-3.817 1.505.022.264a.133.133 0 0 0 .082.135c.048.022.1.012.148-.027.447-.376 1.125-.712 1.67-.524.428.148.718.588.868 1.311.31 1.513-.728 2.243-1.375 2.54l-.022.01-.83.408s-.046.02-.098-.004c-.052-.026-.066-.06-.1-.15-.563-2.08-.755-4.267-.545-6.308a1.07 1.07 0 0 1 .21-.49l.695-.743.078-.084c.378-.368.734-.552.926-.472.16.068.197.322.2.524.031 1.085-.574 2.193-1.845 3.388 0 0-.098.08-.086.224L6 14.664ZM18.512 5.83c.11.038.49.204.724 1.003v-.002c.074.336-.268.236-.268.236a4.836 4.836 0 0 0-2.55-.312c-1.142.172-2.09.724-2.668 1.557-.576.82-.764 1.877-.538 2.983.531 2.548 2.672 3.85 5.456 3.314 1.084-.214 1.953-.674 2.523-1.333.015-.02.103-.116.187-.116.116 0 .188.048.232.212.166.673.148.887.148.887 0 .264-.064.642-.406.937-.763.66-1.75 1.124-2.946 1.384-2.022.423-3.915.132-5.336-.826-1.215-.82-1.995-2.07-2.269-3.618-.27-1.539.082-3.062.992-4.283.867-1.16 2.172-1.953 3.681-2.231a6.36 6.36 0 0 1 3.038.208Z',
      fill: '#fff',
    }),
  );
});
bcSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var bc = {
  category: 'brand',
  colorable: false,
  name: 'bc',
  svg: bcSvg,
};
